(function() {
	'use strict';
	
	angular.module('app.core').filter('slugify', function() {
		return function(input) {
			if (!input || typeof input != 'string') {
				return '';
			}
			return input.toLowerCase()
				.replace(/ /g,'-')
				.replace(/[^\w-]+/g,'');
		};
	});
})();;